import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { get } from '../helper/helper_api'

export default function Header(props) {

    const [cat, setCat] = useState(undefined);
    const [catTwo, setCatTwo] = useState(undefined);

    const [loading, setLoading] = useState(false);

    useEffect(() => {
        getData()
    }, [])

    const getData = () => {
        get('home')
            .then(res => {
                if (res?.statusCode == 200) {
                    setCat(res?.data);
                    let last_two_items = res?.data?.category.slice(-2);
                    setCatTwo(last_two_items)
                    props?.setHeaderData(res?.data)
                }
            }).catch(err => {
                console.log(err)
            })
    }

    const parseTitle = (title) => {
        let str = title.toLowerCase();
        str = str.split(" ").join("-");
        return str;
    }



    return (
        <header class="header-with-topbar">



            <div class="header-top-bar top-bar-light bg-white disable-fixed border-bottom border-color-transparent-dark-very-light">

                <div class="container-fluid">

                    <div class="row h-45px align-items-center m-0">

                        <div class="col-lg-7 col-md-8 text-center text-md-start">

                            <div class="fs-13 text-dark-gray alt-font fw-600">Cultivating Partnership, Delivering Excellence.<a href="index.php" class="text-dark-gray fw-700 text-decoration-line-bottom">Know More</a></div>

                        </div>

                        <div class="col-lg-5 col-md-4 text-end d-none d-md-flex">

                            <a href="#" class="widget fs-13 text-dark-gray fw-600 me-25px md-me-15px text-dark-gray"><i class="feather icon-feather-phone-call"></i>Customer Care</a>

                            <a href="#" class="widget fs-13 text-dark-gray alt-font me-25px fw-600 d-none d-lg-inline-block"><i class="feather icon-feather-map-pin"></i>Find us</a>



                        </div>

                    </div>

                </div>

            </div>

            <nav class="navbar navbar-expand-lg header-light bg-transparent disable-fixed" data-header-hover="light">

                <div class="container-fluid">

                    <div class="col-auto">

                        <Link class="navbar-brand" to="/">

                            <img src="images/apollo-logo-color.png" data-at2x="images/apollo-logo-color.png" alt="" class="default-logo" />

                            <img src="images/dapollo-logo-color.png" data-at2x="images/apollo-logo-color.png" alt="" class="alt-logo" />

                            <img src="images/apollo-logo-color.png" data-at2x="images/apollo-logo-color.png" alt="" class="mobile-logo" />

                        </Link>

                    </div>

                    <div class="col-auto menu-order position-static xs-ps-0">

                        <button class="navbar-toggler float-start" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav" aria-controls="navbarNav" aria-label="Toggle navigation">

                            <span class="navbar-toggler-line"></span>

                            <span class="navbar-toggler-line"></span>

                            <span class="navbar-toggler-line"></span>

                            <span class="navbar-toggler-line"></span>

                        </button>

                        <div class="collapse navbar-collapse justify-content-center" id="navbarNav">

                            <ul class="navbar-nav alt-font">

                                <li class="nav-item"><Link to="/" class="nav-link">Home</Link></li>
                                <li class="nav-item"><Link to="/our-story" class="nav-link">Our Story</Link></li>


                                {/* 
                                <li class="nav-item dropdown submenu">

                                    <a href="javascript:;" class="nav-link">Our Story</a>

                                    <i class="fa-solid fa-angle-down dropdown-toggle" id="navbarDropdownMenuLink2" role="button" data-bs-toggle="dropdown" aria-expanded="false"></i>

                                    <div class="dropdown-menu submenu-content" aria-labelledby="navbarDropdownMenuLink2">

                                        <div class="d-lg-flex mega-menu m-auto flex-column">

                                            <div class="row row-cols-2 row-cols-lg-6 row-cols-sm-3 md-pt-15px align-items-center justify-content-center mb-35px md-mb-30px sm-mb-0">
                                                {
                                                    cat?.category?.map((item, index) => {

                                                        if (index <= cat?.category?.length - 3) {
                                                            // console.log('item', item)
                                                            return (
                                                                <div class="col md-mb-30px">
                                                                    <Link to={`category/${parseTitle(item?.title)}`} className='text-center menu_img'>
                                                                        <img src={item?.image ? item?.image : 'images/menu-category-01.jpg'} alt="" />

                                                                    </Link>
                                                                    <Link to={`category/${parseTitle(item?.title)}`} class="btn btn-hover-animation text-uppercase-inherit fw-600 ls-0px justify-content-center">

                                                                        <span>

                                                                            <span class="btn-text text-dark-gray fs-16">{item?.title}</span>

                                                                            <span class="btn-icon"><i class="fa-solid fa-arrow-right m-0"></i></span>

                                                                        </span>

                                                                    </Link>

                                                                </div>
                                                            )
                                                        }
                                                    })
                                                }

                                            </div>

                                            <div class="row row-cols-1 row-cols-md-2">
                                                {
                                                    catTwo?.map((item, index) => {

                                                        return (
                                                            <div class="col">

                                                                <Link to={`category/${parseTitle(item?.title)}`} >
                                                                    <img src={item?.image} alt="" />
                                                                    <div className='title_text_bg'>
                                                                        <h4>{item?.title}</h4>
                                                                    </div>
                                                                </Link>

                                                            </div>
                                                        )
                                                    })
                                                }



                                            </div>

                                        </div>

                                    </div>

                                </li> */}

                                <li class="nav-item"><Link to="/#" class="nav-link">New & Featured</Link></li>

                                <li class="nav-item"><Link to="/collaboration" class="nav-link">Collaboration</Link></li>

                                <li class="nav-item"><Link to="/#" class="nav-link">Idea and Inspirations</Link></li>

                                <li class="nav-item"><Link to="/contact" class="nav-link">Contact Us</Link></li>

                                <li class="nav-item"><Link to="/blog" class="nav-link">Blogs</Link></li>

                                <li class="nav-item"><Link to="/faqs" class="nav-link">FAQ's</Link></li>





                            </ul>

                        </div>

                    </div>



                </div>

            </nav>

        </header>
    )
}
